import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "@/core/services/store";
import ApiService from "@/core/services/api.service";
import {
  getTranslations,
  prepareConfig
} from "./core/services/i18n.Api.Service";
import { VERIFY_AUTH } from "@/core/services/store/auth.module";
import { RESET_LAYOUT_CONFIG } from "@/core/services/store/config.module";
import mixin from "@/core/mixin/index";
import InfiniteLoading from "vue-infinite-loading";
import VueTippy from "vue-tippy";
import VueSweetalert2 from "vue-sweetalert2";
import VModal from "vue-js-modal";

import * as VueGoogleMaps from "vue2-google-maps";

import "tableexport.jquery.plugin";
import "tableexport.jquery.plugin/libs/FileSaver/FileSaver.min.js";
import "tableexport.jquery.plugin/libs/js-xlsx/xlsx.core.min.js";
import "tableexport.jquery.plugin/tableExport.min.js";

import "tippy.js/themes/light.css";
import "tippy.js/themes/light-border.css";
import "tippy.js/themes/google.css";
import "tippy.js/themes/translucent.css";

import "@/assets/vendors/js/vendors.min";

import $ from 'jquery';
Window.$ = $;

import "@/assets/js/core/app-menu";
import "@/assets/js/core/app";
import "@/assets/js/scripts/components";
import "@/assets/js/scripts/footer";


Vue.use(VueTippy);
Vue.use(VueSweetalert2);
Vue.config.productionTip = false;
import Multiselect from "vue-multiselect";

// register globally
Vue.component("multiselect", Multiselect);

// Global 3rd party plugins
import "popper.js";
import "tooltip.js";
import PerfectScrollbar from "perfect-scrollbar";
window.PerfectScrollbar = PerfectScrollbar;
import ClipboardJS from "clipboard";
window.ClipboardJS = ClipboardJS;
Vue.use(VModal, {});

// Vue 3rd party plugins
import vuetify from "@/core/plugins/vuetify";
import "@/core/plugins/portal-vue";
import "@/core/plugins/bootstrap-vue";
import "@/core/plugins/perfect-scrollbar";
import "@/core/plugins/highlight-js";
import "@/core/plugins/inline-svg";
import "@/core/plugins/apexcharts";
import "@/core/plugins/treeselect";
import "@/core/plugins/metronic";
import "@mdi/font/css/materialdesignicons.css";
import "@/core/plugins/formvalidation";

Vue.use(InfiniteLoading, {
  /* options */
});


Vue.use(VueGoogleMaps, {
  load: {
    key: "AIzaSyBhpogR3ePL3nFimrwAyNdUn3qo8B26taU",
    libraries: "places,drawing,visualization"
  }
});

// API service init
ApiService.init();

router.beforeEach((to, from, next) => {
  // Ensure we checked auth before each page load.
  Promise.all([store.dispatch(VERIFY_AUTH)]).then(next);

  // reset config to initial state
  store.dispatch(RESET_LAYOUT_CONFIG);

  // Scroll page to top on every route change
  setTimeout(() => {
    window.scrollTo(0, 0);
  }, 100);
});

Vue.mixin({
  ...mixin
});

getTranslations().then(({ data }) => {
  let i18n = prepareConfig(data);
  new Vue({
    router,
    store,
    i18n,
    vuetify,
    render: h => h(App)
  }).$mount("#app");
});
